module.exports = function() {
  return new Worker(__webpack_public_path__ + "b9f874cc4e579019a986.worker.js");
};